import { useEffect, useState } from 'react';
import { Button, ListGroup } from 'react-bootstrap';
import { Card, CardBody, CardHeader } from '@components/card/card';

import Loading from '@components/Shared/Loader/Loading';
import ItemConversion from './ItemConversionOld';
import LotItem from './LotItem';
import Attributes from './Attributes';
import ItemsSupplier from './ItemsSupplier';
import AssignmentItemToMultiInventories from './AssignmentItemToMultiInventories';
import AlternativeItems from './AlternativeItems';
import Update from './Update';
import ItemImage from './ItemImage';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { cleanUpMasterItemsById, GetMasterItemsById } from '@store/INV/MasterItems/MasterItemsSlice';
import { useTranslation } from 'react-i18next';
import AssemblyComponents from './AssemblyComponents';
interface Props {
  item: any;
  onClose?: () => void;
  parentId?: string | any;
}

const UpdateItem = ({ onClose, item }: Props) => {
  const { t, i18n } = useTranslation();
  const [mainActiveTab, setMainActiveTab] = useState('basic');
  const isRtl = document.dir === 'rtl';
  const dispatch = useAppDispatch();

  const { MasterItemsById, loading, error } = useAppSelector(a => a.MasterItemsINV);

  // ✅ تحديد هل الصنف تجميعي
  const isAssemblyItem = MasterItemsById?.itemType === 'AssemblyItem';

  useEffect(() => {
    if (item) {
      dispatch(GetMasterItemsById(item.id));
    }
    return () => {
      dispatch(cleanUpMasterItemsById());
    };
  }, []);

  // ✅ لو كان المستخدم على تبويب التجميع ثم تغيّر الصنف وصار غير Assembly
  useEffect(() => {
    if (mainActiveTab === 'assembly' && !isAssemblyItem) {
      setMainActiveTab('basic');
    }
  }, [isAssemblyItem, mainActiveTab]);

  return (
    <>
      <Card className='mb-4 shadow'>
        <CardBody className='p-2'>
          <div className='d-flex align-items-center justify-content-between mb-3'>
            <div className='d-flex align-items-center'>
              <div className='p-3 me-3'>
                <i className='fas fa-box text-theme fa-lg'></i>
              </div>
              <div>
                <h4 className='mb-1 text-theme'>{t('EditItem')}</h4>
                <div className='d-flex align-items-center'>
                  <h5 className='mb-0  fw-bold'>{i18n.language === 'en' ? item.name : item.name2}</h5>
                </div>
              </div>
            </div>
            <button type='button' className='btn-close' onClick={onClose} aria-label={t('Close')}></button>
          </div>
        </CardBody>
      </Card>
      <Loading loading={loading} error={error}>
        <div className='row'>
          <div className='col-lg-3 col-md-4 mb-4'>
            <Card className='shadow-sm'>
              <CardHeader className='border-0 py-3'>
                <h6 className='mb-0'>
                  <i className='fas fa-list me-2 text-theme'></i>
                  {t('Sections')}
                </h6>
              </CardHeader>
              <CardBody className='p-0'>
                <ListGroup variant='flush' className='rounded'>
                  <ListGroup.Item
                    action
                    active={mainActiveTab === 'basic'}
                    onClick={() => setMainActiveTab('basic')}
                    className='border-0 d-flex align-items-center py-3'
                  >
                    <i className='fas fa-id-card me-2'></i>
                    {t('ItemData')}
                    <i className={`fas ${isRtl ? 'fa-chevron-left' : 'fa-chevron-right'} ms-auto`}></i>
                  </ListGroup.Item>

                  <ListGroup.Item
                    action
                    active={mainActiveTab === 'units'}
                    onClick={() => setMainActiveTab('units')}
                    className='border-0 d-flex align-items-center py-3'
                  >
                    <i className='fas fa-balance-scale me-2'></i>
                    {t('Units')}
                    <i className={`fas ${isRtl ? 'fa-chevron-left' : 'fa-chevron-right'} ms-auto`}></i>
                  </ListGroup.Item>

                  <ListGroup.Item
                    action
                    active={mainActiveTab === 'batch'}
                    onClick={() => setMainActiveTab('batch')}
                    className='border-0 d-flex align-items-center py-3'
                  >
                    <i className='fas fa-hashtag me-2'></i>
                    {t('LotNumbers')}
                    <i className={`fas ${isRtl ? 'fa-chevron-left' : 'fa-chevron-right'} ms-auto`}></i>
                  </ListGroup.Item>

                  <ListGroup.Item
                    action
                    active={mainActiveTab === 'attributes'}
                    onClick={() => setMainActiveTab('attributes')}
                    className='border-0 d-flex align-items-center py-3'
                  >
                    <i className='fas fa-tags me-2'></i>
                    {t('ItemAttributes')}
                    <i className={`fas ${isRtl ? 'fa-chevron-left' : 'fa-chevron-right'} ms-auto`}></i>
                  </ListGroup.Item>

                  <ListGroup.Item
                    action
                    active={mainActiveTab === 'suppliers'}
                    onClick={() => setMainActiveTab('suppliers')}
                    className='border-0 d-flex align-items-center py-3'
                  >
                    <i className='fas fa-truck me-2'></i>
                    {t('ItemSuppliers')}
                    <i className={`fas ${isRtl ? 'fa-chevron-left' : 'fa-chevron-right'} ms-auto`}></i>
                  </ListGroup.Item>

                  <ListGroup.Item
                    action
                    active={mainActiveTab === 'warehouses'}
                    onClick={() => setMainActiveTab('warehouses')}
                    className='border-0 d-flex align-items-center py-3'
                  >
                    <i className='fas fa-warehouse me-2'></i>
                    {t('ItemInventory')}
                    <i className={`fas ${isRtl ? 'fa-chevron-left' : 'fa-chevron-right'} ms-auto`}></i>
                  </ListGroup.Item>

                  <ListGroup.Item
                    action
                    active={mainActiveTab === 'alternatives'}
                    onClick={() => setMainActiveTab('alternatives')}
                    className='border-0 d-flex align-items-center py-3'
                  >
                    <i className='fas fa-exchange-alt me-2'></i>
                    {t('AlternativeItems')}
                    <i className={`fas ${isRtl ? 'fa-chevron-left' : 'fa-chevron-right'} ms-auto`}></i>
                  </ListGroup.Item>

                  <ListGroup.Item
                    action
                    active={mainActiveTab === 'ImgItem'}
                    onClick={() => setMainActiveTab('ImgItem')}
                    className='border-0 d-flex align-items-center py-3'
                  >
                    <i className='fas fa-image me-2'></i>
                    {t('ItemImage')}
                    <i className={`fas ${isRtl ? 'fa-chevron-left' : 'fa-chevron-right'} ms-auto`}></i>
                  </ListGroup.Item>

                  {/* ✅ NEW: يظهر فقط لو الصنف AssemblyItem */}
                  {isAssemblyItem && (
                    <ListGroup.Item
                      action
                      active={mainActiveTab === 'assembly'}
                      onClick={() => setMainActiveTab('assembly')}
                      className='border-0 d-flex align-items-center py-3'
                    >
                      <i className='fas fa-layer-group me-2'></i>
                      {t('مكونات الصنف') /* أو t('AssemblyComponents') */}
                      <i className={`fas ${isRtl ? 'fa-chevron-left' : 'fa-chevron-right'} ms-auto`}></i>
                    </ListGroup.Item>
                  )}
                </ListGroup>
              </CardBody>
            </Card>
          </div>

          <div className='col-lg-9 col-md-8'>
            {mainActiveTab === 'basic' && (
              <Card className='shadow-sm'>
                <CardHeader className='bg-theme bg-opacity-50 text-white py-3'>
                  <h5 className='mb-0'>
                    <i className='fas fa-id-card me-2'></i>
                    {t('ItemData')}
                  </h5>
                </CardHeader>
                <CardBody className='p-4'>
                  <Update MasterItemsById={MasterItemsById} />
                </CardBody>
              </Card>
            )}

            {mainActiveTab === 'units' && (
              <Card className='shadow-sm'>
                <CardHeader className='bg-theme bg-opacity-50 text-white py-3'>
                  <h5 className='mb-0'>
                    <i className='fas fa-balance-scale me-2'></i>
                    {t('ItemUnits')}
                  </h5>
                </CardHeader>
                <CardBody className='p-4'>
                  <ItemConversion Item={item} />
                </CardBody>
              </Card>
            )}

            {mainActiveTab === 'batch' && (
              <Card className='shadow-sm'>
                <CardHeader className='bg-theme bg-opacity-50 text-white py-3'>
                  <h5 className='mb-0'>
                    <i className='fas fa-hashtag me-2'></i>
                    {t('LotNumbers')}
                  </h5>
                </CardHeader>
                <CardBody className='p-4'>
                  <LotItem ItemId={item.id} />
                </CardBody>
              </Card>
            )}

            {mainActiveTab === 'attributes' && (
              <Card className='shadow-sm'>
                <CardHeader className='bg-theme bg-opacity-50 text-white py-3'>
                  <h5 className='mb-0'>
                    <i className='fas fa-tags me-2'></i>
                    {t('ItemAttributes')}
                  </h5>
                </CardHeader>
                <CardBody className='p-4'>
                  <Attributes ItemId={item.id} />
                </CardBody>
              </Card>
            )}

            {mainActiveTab === 'suppliers' && (
              <Card className='shadow-sm'>
                <CardHeader className='bg-theme bg-opacity-50 text-white py-3'>
                  <h5 className='mb-0'>
                    <i className='fas fa-truck me-2'></i>
                    {t('ItemSuppliers')}
                  </h5>
                </CardHeader>
                <CardBody className='p-4'>
                  <ItemsSupplier ItemId={item.id} />
                </CardBody>
              </Card>
            )}

            {mainActiveTab === 'warehouses' && (
              <Card className='shadow-sm'>
                <CardHeader className='bg-theme bg-opacity-50 text-white py-3'>
                  <h5 className='mb-0'>
                    <i className='fas fa-warehouse me-2'></i>
                    {t('ItemInventory')}
                  </h5>
                </CardHeader>
                <CardBody className='p-4'>
                  <AssignmentItemToMultiInventories ItemId={item.id} />
                </CardBody>
              </Card>
            )}

            {mainActiveTab === 'alternatives' && (
              <Card className='shadow-sm'>
                <CardHeader className='bg-theme bg-opacity-50 text-white py-3'>
                  <h5 className='mb-0'>
                    <i className='fas fa-exchange-alt me-2'></i>
                    {t('AlternativeItems')}
                  </h5>
                </CardHeader>
                <CardBody className='p-4'>
                  <AlternativeItems ItemId={item.id} />
                </CardBody>
              </Card>
            )}

            {mainActiveTab === 'ImgItem' && (
              <Card className='shadow-sm'>
                <CardHeader className='bg-theme bg-opacity-50 text-white py-3'>
                  <h5 className='mb-0'>
                    <i className='fas fa-image me-2'></i>
                    {t('ItemImage')}
                  </h5>
                </CardHeader>
                <CardBody className='p-4'>
                  <ItemImage ItemId={item.id} />
                </CardBody>
              </Card>
            )}

            {/* ✅ NEW: محتوى التجميع */}
            {mainActiveTab === 'assembly' && isAssemblyItem && (
              <Card className='shadow-sm'>
                <CardHeader className='bg-theme bg-opacity-50 text-white py-3'>
                  <h5 className='mb-0'>
                    <i className='fas fa-layer-group me-2'></i>
                    {t('مكونات الصنف') /* أو t('AssemblyComponents') */}
                  </h5>
                </CardHeader>
                <CardBody className='p-4'>
                  <AssemblyComponents ItemId={item.id} />
                </CardBody>
              </Card>
            )}
          </div>
        </div>
      </Loading>
    </>
  );
};

export default UpdateItem;
